import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import * as VeeValidate from "vee-validate"
import Zondicon from "vue-zondicons"
import VueLodash from "vue-lodash"
import lodash from "lodash"
import VTooltip from "v-tooltip"
import device from "vue-device-detector"
import VueQrcode from "@chenfengyuan/vue-qrcode"

import "./directives"
Vue.use(VeeValidate)
Vue.use(VueLodash, { lodash: lodash })
Vue.use(device)
Vue.use(VTooltip)
Vue.component("Zondicon", Zondicon)
Vue.component(VueQrcode.name, VueQrcode)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app")
